var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetCluster(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 57,
    viewBox: "0 0 52 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "asset_cluster_filter_1",
    width: "125.7%",
    height: "120.9%",
    x: "-12.9%",
    y: "-10.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1.6
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "asset_cluster_ellipse",
    cx: 20.8,
    cy: 20.873,
    rx: 20.4,
    ry: 20.472
  }), /*#__PURE__*/React.createElement("filter", {
    id: "asset_cluster_filter_2",
    width: "107.4%",
    height: "107.3%",
    x: "-3.7%",
    y: "-3.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.188,
    d: "M4.652 44.341c-8.254-4.74-11.364-15.734-6.905-25.297C2.43 8.998 13.695 4.336 22.905 8.63c9.21 4.295 12.879 15.92 8.194 25.966-3.979 8.532-12.703 13.181-20.884 11.758-.79-.004-1.426.081-1.906.257-.748.274-1.752.997-3.014 2.17.088-1.72-.004-2.955-.275-3.703a3.95 3.95 0 0 0-.368-.737zm-1.324 8.307a1.603 1.603 0 0 1-.771-2.131 1.603 1.603 0 0 1 2.128-.78c.801.374 1.147 1.328.772 2.132a1.603 1.603 0 0 1-2.129.779z",
    filter: "url(#asset_cluster_filter_1)",
    transform: "translate(16.8 1.606)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M15.304 44.323a23.99 23.99 0 0 0 5.496.635c1.891 0 3.731-.22 5.496-.635-1.427.556-2.453 1.147-3.077 1.773-.749.752-1.555 2.192-2.419 4.32-.864-2.128-1.67-3.568-2.419-4.32-.624-.626-1.65-1.217-3.077-1.773zM20.8 54.592c-.884 0-1.6-.72-1.6-1.606 0-.887.716-1.606 1.6-1.606.884 0 1.6.72 1.6 1.606 0 .887-.716 1.606-1.6 1.606zm0-13.247C9.533 41.345.4 32.18.4 20.873.4 9.567 9.533.401 20.8.401s20.4 9.166 20.4 20.472c0 11.307-9.133 20.472-20.4 20.472z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#asset_cluster_filter_2)",
    xlinkHref: "#asset_cluster_ellipse"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.35 23.282a.352.352 0 0 0-.35.35v4.918c0 .193.158.351.35.351h.85c0 .665.538 1.205 1.2 1.205.663 0 1.2-.54 1.2-1.205h1.25c.192 0 .35-.158.35-.35v-4.918a.352.352 0 0 0-.35-.351h-4.5zm5.512.803a.264.264 0 0 0-.262.263v4.29c0 .108.069.2.162.238a.269.269 0 0 0 .1.025h.538c0 .665.538 1.205 1.2 1.205.662 0 1.2-.54 1.2-1.205h.537a.242.242 0 0 0 .1-.025.258.258 0 0 0 .138-.138.244.244 0 0 0 .025-.1v-2.07a.252.252 0 0 0-.05-.138l-1.475-2.233a.25.25 0 0 0-.212-.112h-2zm.938.802h1.012l1.063 1.606H22.8v-1.606zM18.4 28.3a.601.601 0 1 1-.002 1.203.601.601 0 0 1 .002-1.203zm5.2 0a.601.601 0 1 1-.002 1.203.601.601 0 0 1 .002-1.203z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetCluster);
export default __webpack_public_path__ + "static/media/asset_cluster.d44dc84a0b511e50e230fb8ed291be28.svg";
export { ForwardRef as ReactComponent };